// extracted by mini-css-extract-plugin
module.exports = {"lightForm":"LrvForm_lightForm__1iNw5","darkForm":"LrvForm_darkForm__N-wMu"};